export default __webpack_public_path__ + "static/media/whitelogo_mc2.2.dc5bc639.png";